import Api from '@common/services/api';
import { EvaluationDetailResponse } from '../types';

export const createEvaluation = async (
  organisationId: string,
  userId: string,
  formId: string,
  payload: {
    reviewerIds: string[];
    deadlineAt?: string | null;
  }
) => {
  const { data } = await Api.post<EvaluationDetailResponse>(
    `/v1/organisations/${organisationId}/users/${userId}/performance/forms/${formId}/evaluations`,
    payload
  );

  return data;
};
